export default {"src":"/_next/static/media/polygon.5c3c0aa1.svg","height":31,"width":131,"blurWidth":0,"blurHeight":0};